import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { UserModuleOutput } from '../model/user-module.output';

export interface FetchUserModulesByUserIdParams {
	readonly userId: string;
}

@Injectable({ providedIn: 'root' })
export class FetchUserModulesByUserIdApiQuery extends ApiQuery<
	UserModuleOutput[],
	FetchUserModulesByUserIdParams
> {
	client = 'content';
	document = gql`
		query FetchUserModulesByUserId($userId: UUID!) {
			fetchUserModulesByUserId(id: $userId) {
				id
				isDone
				userId
				moduleId
				isStarted
				coachComment
				updateTimestamp
				moduleRatingValue
				moduleRatingComment
				isDescriptionVisualized
				generatedUserModulePitch
				generatedUserModuleSynthesis
				generatedUserModulePushSynthesis
				generatedUserModulePushQuestionsSynthesis
				generatedUserModuleLinkedinProposition {
					sectionName
					value
				}
				module {
					id
					updateTimestamp
				}
				pages {
					pageId
					activityUrl
					id
				}
			}
		}
	`;
	method = 'fetchUserModulesByUserId';
}
